const initialState = {
  recentAreaId: false,
};

const UPDATE_RECENT_AREA_ID = 'UPDATE_RECENT_AREA_ID';
export const updateRecentAreaId = recentAreaId => ({
  type: UPDATE_RECENT_AREA_ID, recentAreaId
});

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_RECENT_AREA_ID:
      return { ...state, recentAreaId: action.recentAreaId };
    default:
      return state;
  }
};